import React, { useState, useEffect } from "react";
import HomePage from "./pages/HomePage";
import DonationSuccess from "./pages/DonationSuccess";
import DonationFailed from "./pages/DonationFailed";
import ComingSoon from "./pages/ComingSoon";
import ContactUs from "./pages/ContactUs";
import TermsAndConditions from "./pages/TermsAndConditions";
import RefundCancellation from "./pages/RefundCancellation";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AboutUs from "./pages/AboutUs";
import { checkPaymentStatus } from "./utils/api";

const App = () => {
  const [currentPage, setCurrentPage] = useState('home');
  const [donationData, setDonationData] = useState(null);

  useEffect(() => {
    // Check URL parameters for donation status
    const urlParams = new URLSearchParams(window.location.search);
    const orderId = urlParams.get('order_id');
    const amount = urlParams.get('amount');
    const status = urlParams.get('status');
    const reason = urlParams.get('reason');
    const page = urlParams.get('page');
    
    // Handle navigation pages
    if (page) {
      setCurrentPage(page);
      return;
    }
    
    if (orderId && amount) {
      setDonationData({
        orderId,
        amount: parseFloat(amount),
        status,
        reason
      });
      
      // If status is explicitly set, use it
      if (status === 'failed' || reason) {
        setCurrentPage('failed');
      } else if (status === 'success') {
        setCurrentPage('success');
      } else {
        // If no status is specified, check with backend
        checkPaymentStatusData(orderId, amount);
      }
    }
  }, []);

  const checkPaymentStatusData = async (orderId, amount) => {
    try {
      const data = await checkPaymentStatus(orderId);
      
      console.log('Payment status check:', data);
      
      if (data.status === 'SUCCESS') {
        setCurrentPage('success');
      } else if (data.status === 'FAILED' || data.status === 'CANCELLED' || data.status === 'EXPIRED') {
        setDonationData(prev => ({
          ...prev,
          status: 'failed',
          reason: data.payment_message || 'Payment failed'
        }));
        setCurrentPage('failed');
      } else {
        // Unknown status, default to success for now
        setCurrentPage('success');
      }
    } catch (error) {
      console.error('Error checking payment status:', error);
      // On error, default to success page
      setCurrentPage('success');
    }
  };

  const handleBackToHome = () => {
    setCurrentPage('home');
    setDonationData(null);
    // Update URL without page reload
    window.history.pushState({}, '', '/');
  };

  const handleRetryDonation = () => {
    setCurrentPage('home');
    setDonationData(null);
    // Update URL without page reload
    window.history.pushState({}, '', '/');
  };

  if (currentPage === 'success') {
    return <DonationSuccess donationData={donationData} onBackToHome={handleBackToHome} />;
  }

  if (currentPage === 'failed') {
    return <DonationFailed donationData={donationData} onBackToHome={handleBackToHome} onRetry={handleRetryDonation} />;
  }

  // Handle Contact Us page
  if (currentPage === 'contact') {
    return <ContactUs />;
  }

  // Handle Terms and Conditions page
  if (currentPage === 'terms') {
    return <TermsAndConditions />;
  }

  // Handle Refund and Cancellation page
  if (currentPage === 'refund') {
    return <RefundCancellation />;
  }

  // Handle Privacy Policy page
  if (currentPage === 'privacy') {
    return <PrivacyPolicy />;
  }

  // Handle About Us page
  if (currentPage === 'about') {
    return <AboutUs />;
  }

  // Handle coming soon pages
  if (['programs', 'events', 'video', 'gallery', 'resource', 'blog'].includes(currentPage)) {
    const pageNames = {
      'programs': 'Programs',
      'events': 'Events',
      'video': 'Video Gallery',
      'gallery': 'Photo Gallery',
      'resource': 'Resources',
      'blog': 'Blog'
    };
    return <ComingSoon pageName={pageNames[currentPage]} />;
  }

  return (
    <div>
      <HomePage />
    </div>
  );
};

export default App;
